import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryCards from './components/CategoryCards';
import ContentSections from './components/ContentSections';
import ArticleCTA from './components/ArticleCTA';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoosheet.autos';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Spreadsheet Resource Hub',
  url: siteUrl,
  description: 'The most comprehensive Sugargoo Spreadsheet resource hub for shopping guides, product discovery, shipping information, and expert reviews.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />

      <Navbar />

      <main>
        <HeroSection />

        <div className="py-10 bg-background-50">
          <CategoryDropdown />
        </div>

        <CategoryCards />

        <ContentSections />

        <ArticleCTA />

        {/* Final CTA Banner */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Ready to Start Shopping Smarter?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8">
              Explore the Sugargoo Spreadsheet resources and discover better products today. Thousands of shoppers already use our organized database to find the best deals.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Sugargoo Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-foreground-900 bg-background-50 border-2 border-foreground-200 rounded-lg hover:border-foreground-400 hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}